import gql from 'graphql-tag';
import KEYBOARDING_HOME_USE_SETTING from '../fragments/keyboarding-home-use-setting';

const KEYBOARDING_STUDENT_SETTINGS_FRAGMENT = gql`
  fragment BaseKeyboardingStudentSettings on KeyStudentSettings {
    homeUse {
      ...BaseKeyHomeUseSetting
    }
    skipJumpIn {
      KEYK
      KEY1
      KEY2
      KEY3
      KEY4
      KEY5
    }
    stopAndReview {
      KEYK {
        week
        enabled
      }
      KEY1 {
        week
        enabled
      }
      KEY2 {
        week
        enabled
      }
      KEY3 {
        week
        enabled
      }
      KEY4 {
        week
        enabled
      }
      KEY5 {
        week
        enabled
      }
    }
  }
  ${KEYBOARDING_HOME_USE_SETTING}
`;

export default KEYBOARDING_STUDENT_SETTINGS_FRAGMENT;
